import { NavLink } from "react-router-dom"

function SettingsMenu() {
    return (
        <>

            <ul className="settings-menu">
                <li>
                    <NavLink to="/settings-profile"  className={({ isActive }) => isActive ? "active" : ""}>
                        <a>Profile</a>
                    </NavLink>
                </li>
                <li>
                    <NavLink to="/settings-application"  className={({ isActive }) => isActive ? "active" : ""}>
                        <a>Application</a>
                    </NavLink>
                </li>
                <li>
                    <NavLink to="/settings-security"  className={({ isActive }) => isActive ? "active" : ""}>
                        <a>Security</a>
                    </NavLink>
                </li>
                <li>
                    <NavLink to="/settings-activity"  className={({ isActive }) => isActive ? "active" : ""}>
                        <a>Activity</a>
                    </NavLink>
                </li>
                <li>
                    <NavLink to="/settings-payment-method"  className={({ isActive }) => isActive ? "active" : ""}>
                        <a>Payment Method</a>
                    </NavLink>
                </li>
                <li>
                    <NavLink to="/settings-api"  className={({ isActive }) => isActive ? "active" : ""}>
                        <a>API</a>
                    </NavLink>
                </li>
            </ul>
        </>
    )
}
export default SettingsMenu
